export default __webpack_public_path__ + "static/media/CD.03c45215.svg";